import ShopComponent from "../../components/shopComponent/shopComponent";
import "./shopPage.scss";

const ShopPage = () => {
  return (
    <div className="section-space">
      <div className="shop-page container">
        <ShopComponent />
      </div></div>
  );
};

export default ShopPage;
